export default {
  common: {
    videoVisit: '{{PREMIUM_VISIT_NAME}} video visit',
    inPersonVisit: 'Office visit',
    learnMore: 'Learn more',
  },
  account: {
    drawerCta: 'Get 24/7 access to affordable care with {{MEMBERSHIP_NAME}}',
    navTileTitle: 'Video Visit',
    navTileSubtitle: 'Get seen in minutes, 24/7',
  },
  solvNowEntrypoints: {
    searchFilters: {
      member: {
        title: 'Need care now? Your {{MEMBERSHIP_NAME}} membership has you covered.',
        cta: 'Video chat with a provider now',
      },
      nonMember: {
        title: 'Chat with a doctor anytime, anywhere with instant video visits',
        subtitle:
          'The care you need is only minutes away with {{SOLV_NOW_NAME}}. Even on holidays, nights, & weekends.',
        cta: 'Start a video visit',
      },
    },
  },
  entrypoints: {
    productModal: {
      time: {
        title: 'Video visits within {{PREMIUM_TELEMED_SLA_MINUTES}} minutes',
      },
      fee: 'Membership fee',
      justCost: 'Just {{MONTHLY_MEMBERSHIP_COST_STRING}} per month',
      cta: 'Get care now',
      learnMore: 'Learn more',
    },
    srp: {
      videoVisit: {
        symptomSpecificTitle: '{{PREMIUM_VISIT_NAME}} video visit – {{SYMPTOM_NAME}} consult',
        title: '{{PREMIUM_VISIT_NAME}} video visit',
        hours: {
          title: 'Open',
          subtitle: '24/7, including holidays',
        },
        review: {
          title: 'Most helpful review',
          subtitle:
            'I was seen quickly, without being in a waiting room for hours! Friendly and thorough, an amazing patient experience!',
        },
        price: {
          title: 'Price',
          subtitle: '$79 or $49 with membership',
          learnMore: 'learn more',
        },
        tagline: {
          covid: 'Dealing with COVID? Be seen in 30 minutes or less',
          nonCovid: 'Don’t wait in line - be seen in 30 minutes or less!',
        },
        todayHeader: 'TODAY',
        tomorrowHeader: 'TOMORROW',
        buttonText: 'Start visit now',
        seeMoreText: 'see more',
      },
      title: 'Get seen in {{PREMIUM_TELEMED_SLA_MINUTES}} minutes with {{MEMBERSHIP_NAME}}',
      time: {
        title: '24/7 video visits right when you need them',
        subtitle: 'Get treated for everything from rashes to COVID symptoms',
      },
      cost: {
        title: 'One low price. No surprise bills.',
        subtitle:
          'No insurance? High deductible? Solv Plus video visits are only {{TELEMED_VISIT_COST_STRING}}.',
      },
      cta: 'Get care now',
      secondary: 'Learn more',
    },
    search: {
      member: {
        title: 'Need care now? Your {{MEMBERSHIP_NAME}} membership has you covered.',
        cta: 'Video chat with a provider now',
      },
      nonMember: {
        title: 'Video chat with a provider right now on {{MEMBERSHIP_NAME}}',
        subtitle:
          'Get 24/7 care for you & your kids at one low price per visit, including nights & weekends',
        cta: 'Learn more',
      },
      memberCta: 'Book now',
    },
    upsellModal: {
      headline:
        'Join today to get {{VIDEO_VISIT_MEMBER_DISCOUNT_DOLLARS}} off all {{PREMIUM_VISIT_NAME}} video visits',
      reason1: {
        title: 'Feel better faster with 24/7 care',
        description: 'Includes local clinic referrals if you need to be seen in-person.',
      },
      reason2: {
        title: 'Affordable care for you and your kids',
        description:
          'No insurance? High-deductible plan? {{MEMBERSHIP_NAME}} members pay only {{TELEMED_VISIT_COST_STRING}} per visit.',
      },
      costSummary:
        'Join for {{MONTHLY_MEMBERSHIP_COST_STRING}}/mo or {{ANNUAL_MEMBERSHIP_COST_STRING}}/yr. Cancel anytime.',
      howToSignUp:
        'To sign up, book a {{SOLV_NOW_NAME}} video visit and add a {{MEMBERSHIP_NAME}} membership at checkout',
      cta: 'Return to booking',
      canInitiateBookingCta: 'Sign up and start a visit',
    },
    fullScreenUpsellModal: {
      heroCopy: 'A nurse in your pocket, 24/7',
      reasonsHeadline: 'What you’ll get with {{MEMBERSHIP_NAME}}:',
      reason1: {
        title: '24/7 peace of mind for you & your kids',
        description:
          'Membership gives you and up to 5 kids easy access to affordable care in as little as {{PREMIUM_TELEMED_SLA_MINUTES}} min.',
      },
      reason2: {
        title: '{{VIDEO_VISIT_MEMBER_DISCOUNT_DOLLARS}} savings on every visit',
        description:
          '{{MEMBERSHIP_NAME}} members pay only {{TELEMED_VISIT_COST_STRING}} per {{PREMIUM_VISIT_NAME}} video visit (regularly {{TELEMED_VISIT_COST_STRING_WITHOUT_MEMBERSHIP}}/visit)',
      },
      reason3: {
        title: 'Dedicated support, 7 days a week',
        description: 'Our team is here to help you navigate your care needs, pre and post visit.',
      },
      costSummary:
        'Join for only {{MONTHLY_MEMBERSHIP_COST_STRING}} or {{ANNUAL_MEMBERSHIP_COST_STRING}}/yr (a 45% savings)!',
      join: 'Join Solv Plus',
      decline: 'No thanks',
    },
  },
  landingPage: {
    solvNowSection: {
      title: 'Get care in as little as 30 minutes',
      description: `Not feeling well? Worried about COVID symptoms? Start a video visit 24/7 with an exceptional provider in as little as 30 minutes for just $79 per visit.* This is lightning fast care, now available at your fingertips.`,
      cta: 'Start my video visit',
      membershipPrompt: 'Want to save money on {{SOLV_NOW_NAME}} visits?',
      membershipCta: 'Learn more about {{MEMBERSHIP_NAME}} memberships',
      disclaimer: `*Flat-rate, self-pay price of $79/video visit. Insurance not accepted. No membership required. COVID tests not included. Care providers available for adults and pediatrics. **Only available in select states.`,
    },
    homepage: {
      exclamation: 'New!',
      title: 'Get 24/7 virtual care ASAP with ',
      subtitle:
        'Not feeling well? Worried about COVID symptoms? Start a video visit with a top provider in as little as {{PREMIUM_TELEMED_SLA_MINUTES}} minutes, 24/7, for one low fee.',
      buttonText: 'Join now',
      disclaimer:
        '*Flat-rate, self-pay price. No insurance. **Membership is {{MONTHLY_MEMBERSHIP_COST_STRING}}/month and includes coverage for up to 5 kids. Only {{TELEMED_VISIT_COST_STRING}} per video visit. COVID tests not included. Children must be under 18 years of age to be included on your Solv Plus membership. See Terms of Service for details. **Only available in select states.',
    },
    splash: {
      title: 'Get seen in {{PREMIUM_TELEMED_SLA_MINUTES}} min or less, for COVID and more.',
      availabilityAndCost: '24/7 on-demand care, only {{TELEMED_VISIT_COST_STRING}}/visit.',
      meetWithProviders: 'Speak with a top U.S. based provider by video.',
      simpleMembership: 'One simple membership for you and your kids.',
      disclaimer:
        'Membership is {{MONTHLY_MEMBERSHIP_COST_STRING}}/month. Only {{TELEMED_VISIT_COST_STRING}} per visit. Introductory pricing subject to change.',
      cta: 'Sign up now',
    },
    howItWorks: {
      title: 'A membership built around you.',
      request: {
        title: '24/7 on-demand care',
        description:
          'See an experienced provider in as little as 30 minutes, for COVID concerns and more.',
      },
      connect: {
        title: 'Video visits',
        description: 'Join a video call from your phone or computer, at home or on the go.',
      },
      save: {
        title: 'Save on your care',
        description: 'Pay one flat price per visit. No surprise charges, no insurance necessary.',
      },
    },
    uses: {
      title: 'From everyday care to urgent needs, we’ll be here for you and your children.',
      medical: {
        title: 'Urgent care',
        badges: [
          'Cold & Flu',
          'Fever',
          'Headaches',
          'Pink eye',
          'STIs',
          'Sinus infections',
          'Sore throat',
          'UTIs',
          'Upset stomach',
          'Vomiting',
          'COVID-19',
        ],
      },
      family: {
        title: 'Everyday care',
        badges: ['Allergies', 'Birth control', 'Skin rashes & lesions', 'Travel health'],
      },
      covid: {
        title: 'COVID-19',
        badges: ['Screening', 'Treatment'],
      },
      prescription: {
        title: 'Prescription refills',
        subtitle: 'Fast, stress-free pickup for your medications.',
      },
    },
    membershipForYou: {
      title: 'Is a membership right for you?',
      subtitle:
        'Solv Plus is a great option for affordable, 24/7 guaranteed access to high-quality care.',
      subHeader: 'Solv Plus helps if you… ',
      kidsAtHome: {
        title: 'Have kids at home',
        description:
          'A Solv Plus membership makes urgent care visits more affordable, for all the common concerns (and just-in-case visits) of childhood.',
      },
      deductiblePlan: {
        title: 'Frequently use telehealth or urgent care',
        description:
          'Never worry if you’ll be able to find care or what the cost is going to be. Solv Plus offers no-wait video visits at one low fee, guaranteed.',
      },
      noInsurance: {
        title: 'On a HDHP or don’t have insurance',
        description:
          'If you’re on a HDHP and don’t hit your deductible, you’ll likely save money on care by paying out-of-pocket for Solv Plus instead.',
      },
    },
    pricing: {
      header: 'Simple pricing, no surprises.',
      title: "What's included:",
      costTitle: 'Monthly Membership',
      whatsIncluded: 'Fast 24/7 visits for you & your kids',
      sameDay: 'U.S.-based board certified doctors & nurse practitioners',
      providers: 'No long waits - get seen in <30 minutes',
      quick: 'No unexpected medical bills - one flat rate',
      noWait: 'Coming soon! No-wait in-person urgent care visits at a fixed price',
      monthlyCost: '{{MONTHLY_MEMBERSHIP_COST_STRING}}/mo',
      visitCost: '{{TELEMED_VISIT_COST_STRING}}/visit*',
      disclaimer: 'One adult and up to 5 minor children included',
    },
    faq: {
      title: 'Frequently Asked Questions',
      questionsAndAnswers: {
        what: {
          question: 'What is Solv Plus?',
          answer:
            'Solv Plus is a membership plan offered by Solv that gives you 24/7 unlimited access to high-quality care via video visits with a U.S. based provider, including holidays, nights & weekends, for you and your kids. The membership includes a guarantee that you will receive care within 30 minutes.  You will also receive a premium level of support as part of your membership and will always receive a message back from our support team within the next business day.',
        },
        cost: {
          question: 'How much does the Solv Plus membership cost?',
          answer:
            'The membership fee is $14.99 per month and the video visit fee is $49 per visit. You will be charged the membership fee on a monthly basis.',
        },
        family: {
          question: 'How many family members are included in Solv Plus?',
          answer:
            'Your membership fee includes coverage for you and up to 5 minor children in your household. You will need to pay a visit fee each time you or your child has a video visit with a provider. Please note that as outlined in our <0>Terms of Service</0>, any profile set up on the same account may be viewed by other users under the same account, which may include records, personally identifiable information and information pertaining to their health and healthcare.',
        },
        conditions: {
          question: 'What is included in my membership? What conditions can be treated?',
          answer:
            'You can use your membership for many non-emergency urgent and everyday care concerns, including cough & cold symptoms, minor cuts & bruises, upset stomach, and UTIs. There are some conditions that we aren’t able to treat over video, such as severe shortness of breath, chest pain, persistent vomiting, deep lacerations and possible fractures. However, our providers can order labs as needed, recommend treatment, and prescribe medication if necessary. As always, you can use Solv to find same day in-person care options if there are partners in your area.',
        },
        hsa: {
          question:
            'Can I use my Health Savings Account (HSA) or Flexible Spending Account (FSA) to pay for Solv Plus?',
          answer:
            'The membership fee is not a covered benefit under health insurance plans or other healthcare benefit plans such as a Health Savings Account or Flexible Spending Account. At the time of purchase of a video visit, you will see a fee breakdown explaining the $49 charge; you may be able to submit a claim or use a FSA or HSA debit card to cover the medical services portion of the video visit fee.<br/>Note that a telemedicine portion of the video visit may be eligible for reimbursement with a flexible spending account (FSA), health savings account (HSA) and health reimbursement arrangement (HRA). Telemedicine is generally not eligible for reimbursement with a limited care flexible spending account (LCFSA) or a dependent care flexible spending account (DCFSA).',
        },
        insurance: {
          question: 'Do you need insurance to become a Solv Plus member?',
          answer:
            'Nope! Talking to a doctor or an advanced practice provider (nurse practitioner, physician assistant) is the same affordable price with or without insurance.',
        },
        insuranceForVisits: {
          question: 'Can I use my insurance to pay for my visits?',
          answer:
            'Solv Plus does not accept insurance as there is a simple cash-pay rate for visits.',
        },
        languagesSupported: {
          question: 'What languages are available through Solv Plus?',
          answer: 'Currently Solv Plus only offers service in English.',
        },
        sla: {
          question: 'What if I don’t receive care within 30 minutes?',
          answer:
            'If you request care and are not seen within 30 minutes or less, and you let us know in writing at <0>plussupport@solvhealth.com</0> within 15 calendar days after the video visit, we will refund you for the full cost of the Solv membership fee for the month in which the visit occurred.',
        },
        labs: {
          question: 'What if I need a lab test?',
          answer:
            'If your provider recommends that you get a lab test done, they will order a lab test at a local lab or urgent care near you. You will need to pay separately for the cost of the lab test.',
        },
        rx: {
          question: 'Does my membership include access to prescriptions and prescription refills?',
          answer:
            'Yes, if your provider deems it necessary, they will write a prescription and send it to a local pharmacy convenient for you. The cost of the prescription drug is not covered by your membership or visit fee, and you will need to pay that separately. Of course, you may be eligible for prescription coverage under your applicable insurance plan -- please check with your plan for specifics.',
        },
        covidtest: {
          question: 'Does Solv Plus include COVID testing?',
          answer:
            'Currently, Solv Plus does not include COVID testing. However, your provider can help by screening you for COVID, helping you manage COVID-related symptoms, and providing a doctor’s note if needed for work or school.',
        },
        states: {
          question: 'Is Solv Plus available in all 50 states? What if I go on vacation?',
          answer:
            'Currently, Solv Plus is available to residents of {{states}}. When traveling, you will be able to use your membership if you are located within the states that are listed here. We will be adding many more states soon so check back often to see when your area has coverage. Solv Plus is not available outside of the United States.',
        },
        cancel: {
          question: 'What if I want to cancel my membership?',
          answer:
            'The membership fee is a recurring fee and will be billed monthly; however, you can cancel your membership at any time via your Account or by emailing plussupport@solvhealth.com. As long as you cancel your membership three days before the next billing period, you will not be billed the monthly fee for the next period. See our <0>Terms of Service</0> for more details.',
        },
        provider: {
          question: 'What if I’m a provider who wants to be involved with Solv Plus?',
          answer:
            'For more information about the benefits of participating in the Solv Plus network, please <0>apply here to get on the waitlist</0> and we will be in touch. There is no cost to participate.',
        },
        questions: {
          question: 'What if I have another question not answered here?',
          answer:
            'We’d be happy to help. Just send us an email at plussupport@solvhealth.com and we’ll get back to you soon.',
        },
      },
      inPersonQuestionsAndAnswers: {
        what: {
          question: 'What is Solv Plus?',
          answer:
            'Solv Plus is a membership plan offered by Solv that gives you same-day access to in-person visits at local urgent care clinics near you at a low fixed price and 24/7 unlimited access to high-quality care via video visits with a U.S. based provider. You will also receive a premium level of support as part of your membership and will always receive a message back from our support team within the next business day.',
        },
        selfPay: {
          question: 'What are self-pay prices?',
          answer:
            'Self-pay prices (also commonly known as “cash” pay prices) refer to the prices that you would pay for services if you didn’t have insurance or if you didn’t want your insurance to be billed.',
        },
        tiers: {
          question: 'In-person visit price tiers by geo:',
          answer: `Dallas-Fort Worth, Texas<br/>
            Tier 1: \${{DFW_LOW_PRICE}}/visit<br/>
            Tier 2: \${{DFW_MID_PRICE}}/visit<br/>
            Tier 3: \${{DFW_HIGH_PRICE}}/visit<br/><br/>

            New Jersey<br/>
            Tier 1: \${{NJ_LOW_PRICE}}/visit<br/>
            Tier 2: \${{NJ_MID_PRICE}}/visit<br/>
            Tier 3: \${{NJ_HIGH_PRICE}}/visit<br/>
            `,
        },

        'tiers-explained': {
          question: 'What is included in each pricing tier?',
          answer: `
          <strong>Tier 1:</strong> A basic office visit includes an evaluation of symptoms, a treatment plan, and if applicable, a prescription for medications.<br /><br />
          <strong>Tier 2:</strong> Basic office visit +in-house lab tests*:<br/>
          Example: Strep, flu, mono, pregnancy, blood glucose, urine dip, urine pregnancy, RSV<br/>
          *Please note that the exact in-house labs offered at each clinic may vary depending on CLIA status and operating model - check with your provider at the time of visit. Additional lab tests not listed here that need to be sent to an outside lab are the responsibility of the patient (for example: thyroid test, complete blood cell count and chemistry panel).<br/><br />
          <strong>Tier 3:</strong> Everything in Tier 2 + the following services:<br/>
          X-rays, injections, laceration repair (including stitches), foreign body removal, incision and drainage.
          `,
        },

        notIncluded: {
          question: 'What is not included in my visit fees?',
          answer: `
          <ul>
            <li>Durable Medical Equipment (Crutches, Splints, etc.); these products are provided and billed through an outside vendor, but may be covered by a medical insurance plan if you have one.</li>
            <li>Services performed by outside facilities; these will be billed to you or your insurance company separately by the providing institutions, and may include but are not limited to Imaging Services (MRI’s, CT scans, Ultrasounds, etc.) and laboratory services not performed within participating urgent care clinics.</li>
            <li>Prescription medications</li>
            <li>Specialty referrals</li>
            <li>COVID-19 tests</li>
          </ul>
          `,
        },

        cost: {
          question: 'How much does the Solv Plus membership cost?',
          answer:
            'The membership fee is $14.99 per month and the video visit fee is $49 per visit. You will be charged the membership fee on a monthly basis.',
        },
        family: {
          question: 'Can I use Solv Plus for my family? Can Solv Plus providers see kids?',
          answer:
            'Your membership fee includes coverage for you and up to 5 minor children in your household. You will need to pay a visit fee each time you or your child has a video visit with a provider. Please note that as outlined in our <0>Terms of Service</0>, any profile set up on the same account may be viewed by other users under the same account, which may include records, personally identifiable information and information pertaining to their health and healthcare.',
        },
        conditions: {
          question: 'What is included in my membership? What conditions can be treated?',
          answer:
            'You can use your membership for many non-emergency urgent and everyday care concerns, including cough & cold symptoms, minor cuts & bruises, upset stomach, and UTIs. There are some conditions that we aren’t able to treat over video, such as severe shortness of breath, chest pain, persistent vomiting, deep lacerations and possible fractures. However, our providers can order labs as needed, recommend treatment, and prescribe medication if necessary. As always, you can use Solv to find same day in-person care options if there are partners in your area.',
        },
        hsa: {
          question:
            'Can I use my Health Savings Account (HSA) or Flexible Spending Account (FSA) to pay for Solv Plus?',
          answer:
            'The membership fee is not a covered benefit under health insurance plans or other healthcare benefit plans such as a Health Savings Account or Flexible Spending Account. At the time of purchase of a video visit, you will see a fee breakdown explaining the $49 charge; you may be able to submit a claim or use a FSA or HSA debit card to cover the medical services portion of the video visit fee.<br/>Note that a telemedicine portion of the video visit may be eligible for reimbursement with a flexible spending account (FSA), health savings account (HSA) and health reimbursement arrangement (HRA). Telemedicine is generally not eligible for reimbursement with a limited care flexible spending account (LCFSA) or a dependent care flexible spending account (DCFSA).',
        },
        insurance: {
          question: 'Do you need insurance to enroll in Solv Plus?',
          answer:
            'Nope! Talking to a doctor or an advanced practice provider (nurse practitioner, physician assistant) is the same affordable price with or without insurance.',
        },
        insuranceForVisits: {
          question: 'Can I use my insurance to pay for my visits?',
          answer:
            'Solv Plus does not accept insurance as there is a simple cash-pay rate for visits.',
        },
        referral: {
          question: 'Do I need a referral to go to an in-person provider?',
          answer:
            'No, it’s your choice! You can choose if you want to be seen on video or in-person.',
        },

        languagesSupported: {
          question: 'What languages are available through Solv Plus?',
          answer: 'Currently Solv Plus only offers service in English.',
        },
        sla: {
          question: 'What if I don’t receive care within 30 minutes?',
          answer:
            'If you request care and are not seen within 30 minutes or less, and you let us know in writing at <0>plussupport@solvhealth.com</0> within 15 calendar days after the video visit, we will refund you for the full cost of the Solv membership fee for the month in which the visit occurred.',
        },
        labs: {
          question: 'What if I need a lab test?',
          answer:
            'If your provider recommends that you get a lab test done, they will order a lab test at a local lab or urgent care near you. You will need to pay separately for the cost of the lab test.',
        },
        rx: {
          question: 'Does my membership include access to prescriptions and prescription refills?',
          answer:
            'Yes, if your provider deems it necessary, they will write a prescription and send it to a local pharmacy convenient for you. The cost of the prescription drug is not covered by your membership or visit fee, and you will need to pay that separately. Of course, you may be eligible for prescription coverage under your applicable insurance plan -- please check with your plan for specifics.',
        },
        covidTest: {
          question: 'Does Solv Plus include COVID testing?',
          answer:
            'Currently, Solv Plus does not include COVID testing. However, your provider can help by screening you for COVID, helping you manage COVID-related symptoms, and providing a doctor’s note if needed for work or school.',
        },
        states: {
          question: 'Is Solv Plus available in all 50 states? What if I go on vacation?',
          answer:
            'Currently, Solv Plus is available to residents of {{states}}. When traveling, you will be able to use your membership if you are located within the states that are listed here. We will be adding many more states soon so check back often to see when your area has coverage. Solv Plus is not available outside of the United States.',
        },
        cancel: {
          question: 'Are there any cancellation fees?',
          answer: `If you book an in-person or video visit but no longer need care, you can cancel your visit at any time without any penalty.<br/>
            The membership fee is a recurring fee and will be billed monthly; however, you can cancel your membership at any time via your Account or by emailing plussupport@solvhealth.com. As long as you cancel your membership three days before the next billing period, you will not be billed the monthly fee for the next period. See our <0>Terms of Service</0> for more details.`,
        },
        provider: {
          question: 'What if I’m a provider who wants to be involved with Solv Plus?',
          answer:
            'For more information about the benefits of participating in the Solv Plus network, please <0>apply here to get on the waitlist</0> and we will be in touch. There is no cost to participate.',
        },
        questions: {
          question: 'What if I have another question not answered here?',
          answer:
            'We’d be happy to help. Just send us an email at plussupport@solvhealth.com and we’ll get back to you soon.',
        },
      },
    },
    contactUs: {
      title: 'Have a different question?',
      subtitle:
        'We’d be happy to help. Just send us an email at {{MEMBERSHIP_SUPPORT_EMAIL}} and we’ll get back to you soon.',
    },
    providerSection: {
      title: 'Information for Healthcare Providers',
      description:
        'Today, our 24/7 telehealth providers are trained on how to refer patients that need a higher level of care to in-person Solv partners. In the future, Solv Plus members will be able to schedule no-wait, flat fee in-person visits, providing opportunities for partners to participate further. Partners will also have the opportunity to provide telehealth services as part of Solv Plus.',
      interested:
        'If you’re a provider and are interested in participating with Solv Plus, we’d love to hear from you!',
      waitlistUrlText: 'Apply here to get on our waitlist',
      willBeInTouch: 'and we’ll be in touch when there is availability in your market.',
    },
    cta: 'Sign me up',
  },
  payment: {
    title: 'Enter payment details',
    maybeNotAvailable: '{{MEMBERSHIP_NAME}} might not be available in your state yet.',
    genericError: 'A processing error occurred',
    cardDeclined: 'Your payment failed. Please try another card or payment method.',
    seeSupportedStates: 'See which states we support',
    monthlyMembershipLineItemTitle: 'Monthly {{MEMBERSHIP_NAME}} membership',
    monthlyMembershipLineItemSubtitle: 'Billed monthly, cancel anytime.',
    annualMembershipLineItemTitle: 'Annual {{MEMBERSHIP_NAME}} membership',
    annualMembershipLineItemSubtitle: 'Billed annually, cancel anytime.',
    visitLineItemSubtitle: 'Billed after visit, no insurance accepted.',
    telemedLineItemTitle: '{{SOLV_NOW_NAME}} video visit',
    inPersonLineItemTitle: '{{MEMBERSHIP_NAME}} in-person visit',
    costPerMonth: '{{MONTHLY_MEMBERSHIP_COST_STRING}}/month',
    costPerYear: '{{ANNUAL_MEMBERSHIP_COST_STRING}}/year',
    totalDueAfterVisit: 'Total due after visit',
    totalDueNow: 'Total due now',
    cardDetails: 'Card details',
    chargeToCard: 'Charge to {{CARD_BRAND}} ending in ****{{CARD_LAST_FOUR}}',
    membershipUpsell: {
      saveByJoining:
        '<0>Save {{DOLLARS_SAVED}}</0> on every Solv Now video visit by joining {{MEMBERSHIP_NAME}}!',
      learnMore: 'Learn more',
    },
    errors: {
      alreadyHasMembership: {
        title: 'You already have a membership',
        bookAVisit: 'Book a visit now',
        goHome: 'Go to my account',
      },
      problemWithCard: 'There is a problem with {{CARD_BRAND}} ending in ****{{CARD_LAST_FOUR}}.',
    },
    solvEmployee: {
      title: 'You are a Solv employee',
      subtitle:
        'Please use your real credit card on this form. You will not be charged any monthly fee, but you will be responsible for all $49 video visit fees.',
    },
    legal: {
      monthlyChargeDescription:
        'You will be charged {{MONTHLY_MEMBERSHIP_COST_STRING}} automatically every month until you cancel.',
      annualChargeDescription:
        'You will be charged {{ANNUAL_MEMBERSHIP_COST_STRING}} automatically every year until you cancel.',
      preButton:
        'Your price may change as described in Solv’s <1>Terms of Service</1>. This card will be charged automatically for the visit fee after each completed visit. You can <2>cancel your membership</2> at any time in the Solv app or by <3>contacting support.</3>',
      postButton:
        'By clicking Subscribe, you agree to Solv’s <1>Terms of Service</1> and <2>Privacy Policy.</2> You acknowledge that you are not covered by Medicare or any federal or state Medicaid programs and that amounts paid are intended for cash pay.',
    },
    supportedStates: {
      title: '{{MEMBERSHIP_NAME}} supported states',
      subtitle:
        'We are adding new states to {{MEMBERSHIP_NAME}} all the time. You must physically be in one of these states at the time of your visit to use Solv Plus services. Right now, the supported states are:',
    },
    warning: {
      titleNoState: `We can't confirm that Solv plus is available in your area.`,
      title: 'Solv plus is not yet available in {{state}}.',
      subtitle: 'We do not have providers licensed in that state to provide care.',
      subtitleNoState: 'We might not have providers licensed in your state to provide care.',
      cta: 'Subscribe anyway',
    },
    subscribe: 'Subscribe and continue',
    membershipPlanSelection: {
      title: 'Choose your Solv Plus subscription',
      subtitle:
        'Get amazing care with member-exclusive visit prices for you and your kids. Cancel anytime.',
      monthly: { title: 'Monthly' },
      annual: {
        title: 'Annual',
        valueProp: 'Pay $99 upfront and save 40%',
        savings: 'Best value',
      },
    },
    promoDiscountDescription:
      'We’ll automatically take {{ DOLLAR_AMOUNT }} off your Solv Now video visit fee after your visit is complete.',
    promoDiscountHeader: 'You have a {{ DOLLAR_AMOUNT }} Solv Now credit',
  },
  titles: {
    location: 'Visit location',
    newLocation: 'Visit location',
    time: 'Visit time',
    login: 'Login',
    payment: 'Payment',
    profile: 'Visit profile',
    newProfile: 'New Profile',
    reason: 'Reason for Visit',
    finalize: 'Finalize Visit',
    default: 'Book',
    bookingFlow: '{{SOLV_NOW_NAME}} video visit',
  },
  timeSlots: {
    sla: 'Within next {{sla}} minutes',
    timePrompt: 'When do you want your visit?',
    timePromptVideo: 'When do you want your video visit?',
    seeAllTimes: 'See all times',
    seeFewerTimes: 'See fewer times',
    loading: 'Loading available time slots',
  },
  stateConfirmation: {
    title: 'Where will the patient be at the time of the video visit?',
    subtitle: 'This helps us connect you to the best provider for your needs',
    locating: 'Finding your location',
    otherState: 'Somewhere else',
    noDetectedState: 'Choose a state',
    stateError: {
      title: `We're not sure where you are`,
      subtitle: 'Please select the state you are currently in so we can match you with a provider.',
    },
  },
  stateSelection: {
    title: 'Select a state',
    subtitle:
      'This helps us connect you to a provider licensed in the same state the patient will be in.',
    notFindingStateTitle: 'Not finding your state?',
    notFindingStateCopy:
      'If your state is not listed above, {{PREMIUM_VISIT_NAME}} is not yet available. You can return to search for care at clinics on Solv.',
    notFindingStateCta: 'Find care on Solv',
    selectAnotherState: 'Select another state',
    loading: 'Loading supported states',
  },
  selectProfile: {
    title: 'Who is this visit for?',
    subtitle: 'Please select or add a family member below',
    months: '{{count}} month',
    months_plural: '{{count}} months',
    years: '{{count}} year',
    years_plural: '{{count}} years',
    adultAge: '$t(selectProfile.years, { "count": {{count}} }) old',
    childAge:
      '$t(selectProfile.years, { "count": {{years}} }) $t(selectProfile.months, { "count": {{months}} }) old',
    addProfile: 'Add a family member',
    loading: 'Loading your profiles',
  },
  successDialog: {
    title: 'Welcome to our newest {{MEMBERSHIP_NAME}} member!',
    subtitle:
      'You’re on the road to great health! You and up to 5 kids now have access to amazing care with clear upfront prices and no surprise bills.',
    cta: 'View my benefits',
  },
  newProfile: {
    title: 'Who is this visit for?',
    subtitle: "Please add the patient's information below",
    error:
      'Something went wrong. Please check that all of your fields are correct and try again, or try again later.',
    nameRequired: 'First and last name are required',
    birthDateRequired: 'Birth date is required',
    first: 'First name',
    last: 'Last name',
    patientName: 'Patient Name',
    birthDate: 'Patient date of birth',
    relationship: "Patient's relationship to you",
    relationships: {
      self: 'Self',
      parent: 'Parent',
      sibling: 'Sibling',
      child: 'Child',
      spouse: 'Spouse',
      other: 'Other',
    },
    sex: 'Patient birth sex',
    sexes: {
      female: 'Female',
      male: 'Male',
      other: 'Other',
    },
  },
  reasonForVisit: {
    title: 'How can we help?',
    subtitle: 'Briefly describe the reason for visit',
    useFor: 'Use {{PREMIUM_VISIT_NAME}} video visits for',
    issuesNotTreated: 'Not supported in video visits',
    reason: {
      cold: 'Minor colds, coughs, & flus',
      cuts: 'Minor cuts, scrapes, & burns',
      rashes: 'Some rashes',
      allergies: 'Seasonal allergies',
      prescriptions: 'Prescriptions',
      uti: 'UTI',
      questions: 'General questions or concerns',
      headInjuries: 'Major head injuries',
      covidTests: 'Covid tests',
      sports: 'Sports physicals',
      wellness: 'Wellness exams',
      vaccine: 'Vaccines',
      controlledSubstances: 'Prescriptions for controlled substances',
    },
  },
  finalizeVisit: {
    membership: '{{MEMBERSHIP_NAME}} Membership',
    discountCostHeader: 'Visit fee ({{VIDEO_VISIT_MEMBER_DISCOUNT_PERCENT}} off)',
    promoDiscountHeader: 'Solv Now credit',
    inPersonCostHeader: 'Visit fee',
    inPersonCost: '{{LOW_COST}} – {{HIGH_COST}}',
    title: 'Review and book',
    subtitle: 'You’re almost done! Please review the information below and confirm your booking.',
    visitDetails: 'Visit details',
    paymentDueAfterVisit: 'Payment due after visit',
    patient: 'Patient',
    service: 'Service',
    when: 'When',
    where: 'Where',
    costHeader: 'Amount',
    paymentMethod: 'Payment method',
    chargedAfter: 'charged after visit',
    smsConsent:
      'You agree to receive text messages from Solv about your visit. Message and data rates may apply.',
    confirmBooking: 'Confirm booking',
    cardAlert: {
      description: {
        invalid: 'Your saved payment method is no longer valid.',
        noCard: 'You have no saved payment method',
        paymentHoldFailed: "We couldn't process your payment hold",
      },
      action: {
        addPaymentMethod: 'Please add a new payment method',
        switchPaymentMethod: 'Please try another payment method',
      },
    },
    errors: {
      slotTaken: {
        body: 'Sorry, the time you selected is no longer available',
        action: 'Please select a new time',
      },
    },
    updateCard: 'Update payment method',
    addCard: 'Add payment method',
    legal:
      'By clicking “Confirm booking”, you agree to Solv’s <1>Terms of Service</1> and <2>Privacy Policy</2>. <3>You also ' +
      'authorize Solv to place a temporary authorization hold on your payment ' +
      'method for the amount listed. After your appointment is complete, your payment method ' +
      'will be charged for the visit and the hold will be removed. It may take up to 5-7 ' +
      'business days to reflect these changes in your bank account statement.</3>',
  },
  feesModal: {
    title: '{{PREMIUM_VISIT_NAME}} Telehealth Services',
    memberCopy:
      '<p>The {{TELEMED_VISIT_COST_STRING}} video visit price includes the medical services cost for an independent health care provider not affiliated with Solv Health to conduct your telehealth visit, plus fees for other administrative, technology and operational support.</p><p>Of the {{TELEMED_VISIT_COST_STRING}} fee, {{CARD_PROCESSING_FEE}} is charged as a credit card processing fee, {{STEADYMD_FEE}} is paid to the independent healthcare provider for medical services, and the remainder is paid to Solv Health, Inc. for technology and administrative support. These charges are non-refundable.</p>',
    nonMemberCopy:
      '<p>The {{TELEMED_VISIT_COST_STRING_WITHOUT_MEMBERSHIP}} video visit price includes the medical services cost for an independent healthcare provider not affiliated with Solv Health to conduct your telehealth visit, plus fees for other administrative, technology and operational support.</p><p>Of the {{TELEMED_VISIT_COST_STRING_WITHOUT_MEMBERSHIP}} fee, {{CARD_PROCESSING_FEE}} is charged as a credit card processing fee, {{STEADYMD_FEE}} is paid to the independent healthcare provider for medical services, and the remainder is paid to Solv Health, Inc. for technology and administrative support. These charges are non-refundable.</p>',
    dontSubmitCopy:
      'These amounts are not intended to be submitted to any health care plan. For information, see our <1>Terms of Service</1>.',
  },
  smsConsentDialog: {
    title: 'Appointment texts are currently turned off.',
    body: 'You previously opted-out from receiving text messages from Solv. In order to receive important messages about your visit, you’ll need to opt back in. Message and data rates may apply.',
    grantConsent: 'Allow SMS text messages',
    declineConsent: 'Continue without consent',
  },
  inPersonPricesModal: {
    title: 'How much will my visit cost?',
    subtitle: `Solv works closely with providers to offer members discounted clear prices. How much
    you are charged depends on services administered during your visit.`,
    tier1: {
      title: 'Tier 1 visit',
      description:
        'The basic office visit includes an evaluation of symptoms, treatment plan, and any prescriptions.',
    },
    tier2: {
      title: 'Tier 2 visit',
      description: 'Includes Tier 1 plus lab tests such as strep, flu and pregnancy.',
    },
    tier3: {
      title: 'Tier 3 visit',
      description:
        'Everything in Tier 1 and 2 plus additional services such as x-rays, stitches, and IVs.',
    },
  },
  premiumInPersonLocationSelector: {
    title: 'When do you want to visit?',
    alert: {
      title: 'Other options available',
      subtitle:
        'Book a Solv Now video visit (member price is $49) or search local clinics not currently partnered with Solv Plus.',
      startVisit: 'Solv Now video visit',
      search: 'Search other clinics',
    },
    noTimesAvailable: 'No times available',
    seeOtherDays: 'See other days',
  },
  inPerson: {
    pediatricOnly: 'Pediatric-only',
    pediatricOnlyAlert:
      'Solv Plus in-person visits in your area are only available for patients under 21 years old.',
  },
};
